import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

/**
 * CustomHammerConfig
 */
@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {}
